import api from './api';

export const aiService = {
    // Note: AI Services API endpoints are not yet implemented in the backend
    // These are placeholder functions that will return mock data until the backend API is ready

    async sendChatMessage(message, context = {}) {
        // For now, return a mock response since the endpoint doesn't exist
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    id: Date.now(),
                    sender: 'ai',
                    content: `I understand you're looking for gift recommendations. Based on your message "${message}", I'd suggest exploring our trending products or using our gift finder to discover personalized options.`,
                    timestamp: new Date(),
                    suggestions: [
                        'Check trending products',
                        'Use the gift finder',
                        'Browse by occasion'
                    ]
                });
            }, 1000 + Math.random() * 1000); // Simulate API delay
        });
    },

    async getGiftSuggestions(preferences) {
        // Mock response until backend API is ready
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    suggestions: [
                        { id: 1, title: 'Wireless Headphones', price: '$99.99', reason: 'Popular tech gift' },
                        { id: 2, title: 'Coffee Maker', price: '$79.99', reason: 'Great for coffee lovers' },
                        { id: 3, title: 'Book Set', price: '$29.99', reason: 'Perfect for readers' }
                    ],
                    confidence: 0.85
                });
            }, 800);
        });
    },

    async analyzeBudget(data) {
        // Mock response until backend API is ready
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    budget_analysis: {
                        recommended_range: `$${data.min_budget || 25} - $${data.max_budget || 100}`,
                        suggestions: [
                            'Consider gifts in the $50-75 range for best value',
                            'Look for seasonal discounts',
                            'Bundle smaller items for more impact'
                        ]
                    }
                });
            }, 600);
        });
    },

    async getPersonalizedRecommendations(userProfile) {
        // Mock response until backend API is ready
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    recommendations: [
                        { id: 1, title: 'Smart Watch', score: 0.92 },
                        { id: 2, title: 'Bluetooth Speaker', score: 0.88 },
                        { id: 3, title: 'Plant Care Kit', score: 0.85 }
                    ]
                });
            }, 700);
        });
    },

    async getChatHistory() {
        // Mock response until backend API is ready
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    conversations: [],
                    total: 0
                });
            }, 300);
        });
    },

    async startNewConversation() {
        // Mock response until backend API is ready
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    conversation_id: Date.now(),
                    message: 'New conversation started! How can I help you find the perfect gift today?'
                });
            }, 200);
        });
    }
}; 